import { render, staticRenderFns } from "./evaluation.vue?vue&type=template&id=61d3a482&scoped=true&"
import script from "./evaluation.vue?vue&type=script&lang=js&"
export * from "./evaluation.vue?vue&type=script&lang=js&"
import style0 from "./evaluation.vue?vue&type=style&index=0&id=61d3a482&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d3a482",
  null
  
)

export default component.exports